/**
 * Post Recommend Setup
 * Entry point / integration (DI)
 */

import { PostRecommendApi } from "./post-recommend-api";
import { PostRecommendHandler } from "./post-recommend-handler";
import { PostRecommendListener } from "./post-recommend-listener";
import { PostRecommendRender } from "./post-recommend-render";

class PostRecommendSetup {
    public static init(): void {
        if (document.documentElement.dataset.postRecommendInit === "1") return;
        document.documentElement.dataset.postRecommendInit = "1";

        const render = new PostRecommendRender();
        const handler = new PostRecommendHandler({ api: PostRecommendApi, render });
        const listener = new PostRecommendListener({ handler });
        listener.register();
    }
}

function initPostRecommendSystem(): void {
    PostRecommendSetup.init();
}

export { PostRecommendSetup, initPostRecommendSystem };
